import { SignupForm } from "@/components/Complex/SignupForm"
import { signupLink } from "@/lib/api/auth"
import { useConfig } from "@/hooks/useConfig"
import { useNavigate } from "react-router-dom"
import { useState } from "react"
import { z } from "zod/v4"
import { useSignupStore } from "@/lib/store/signupStore"
import axios from "axios"
import { AuthLayout } from "@/components/Primitives/AuthLayout"

export function SignupPage() {
  const navigate = useNavigate()
  const { t } = useConfig()
  const [email, setEmail] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [error, setError] = useState("")
  const { setEmail: setStoreEmail } = useSignupStore()

  const handleSubmit = async () => {
    try {
      setError("")

      const emailSchema = z
        .email(t("config_sign_up_error_email_invalid"))
        .min(5, t("config_sign_up_error_email_short"))
        .max(100, t("config_sign_up_error_email_long"))

      const result = emailSchema.safeParse(email)

      if (!result.success) {
        const issues = result.error.issues
        setError(issues[0]?.message || t("config_sign_up_error_email_invalid"))
        return
      }

      setIsSubmitting(true)
      await signupLink(email)
      setStoreEmail(email)
      navigate("/signup/email")
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const status = error.response?.status
        if (status === 409) {
          setError(t("config_sign_up_error_conflict"))
        }
      } else {
        console.error("Signup failed:", error)
        setError(t("config_sign_up_error_generic"))
      }
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <AuthLayout
      description={t("config_sign_up_hero_description")}
      imageUrl="/images/open-box.webp"
    >
      <SignupForm
        email={email}
        onEmailChange={setEmail}
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        error={error}
      />
    </AuthLayout>
  )
}
